import React from 'react';
import dynamic from "next/dynamic";
import { getInitialData } from "../service/apiFetch";

const Photogallery = dynamic(() => import("../components/Gallery/Photogallery"), {
  ssr: false,
});

export const getStaticProps = async () => {
  const initialData = await getInitialData('photo-gallery', { contentBlock: 'Object' });

  return {
    props: {
      websiteData: initialData?.websiteData || "",
      data: initialData?.data || "",
      title: initialData?.title || "",
      metaTags: initialData?.metaTags || "",
      url: initialData?.url || "",
      error: initialData?.error || "",
    },
  };
};

export default function PhotogalleryPage({ data }) {
  return (
    <div>
     
      {data?.contentBlock?.PHOTO_GALLERY ? (
        <Photogallery data={data?.contentBlock?.PHOTO_GALLERY} />
      ) : (
        <p>No photo gallery data available.</p>
      )}
    </div>
  );
}
